module.exports = {"navigation":{"insurance_inquiry":["Insurance Inquiry","Forespørgsel"],"my_insurances":["My insurances","Mine forsikringer"],"my_profiles":["My profiles","Mine profiler"],"special_deals":["Special deals","Specialtilbud"],"settings":["Settings","Indstillinger"],"help":["Help","Hjælp"],"logout":["Logout","Log ud"],"business":["Business","Erhverv"],"personal":["Private","Privat"],"terms":["Terms","Betingelser"],"politics":["Privacy Policy","Persondata politik"]}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/navigation.locale.json
// module id = 689
// module chunks = 0